import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class BilDashboardService {

  constructor(private http: HttpClient) { }

  getApplicationData() {
    if(localStorage.getItem('isPayLater')) {
      return this.http.get(environment.basePath + '/dashboard/dsk/application/PL');
    } else {
      return this.http.get(environment.basePath + '/dashboard/dsk/application/bil');
    }
  }
  
  getTechInfoStatus() {
    return this.http.get(environment.basePath + '/dashboard/getTechInfoStatus');
  }

  getFIApplicationData() {
    return this.http.get(environment.url + '/bil-fi/application/details?fiName=LK');
  }

}
